import React, { useEffect } from "react";
import { MistyLogo } from "./ImageSlot";
import { lock, unlock } from "./scrollLock";

export const AgeGate = ({ open, onConfirm }) => {
  useEffect(() => {
    if (!open) {
      unlock("age-gate");
      return undefined;
    }
    lock("age-gate");
    return () => unlock("age-gate");
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-misty-base/95 backdrop-blur-2xl px-6 text-center"
      data-testid="age-gate-overlay"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(74,144,217,0.12),transparent_60%)]" />
      <div className="relative z-10 flex flex-col items-center gap-10 max-w-xl animate-fade-up">
        <MistyLogo size="lg" testId="age-gate-logo" />
        <div className="w-12 h-px bg-misty-steel/40" />
        <div className="flex flex-col gap-3">
          <p className="text-[10px] tracking-[0.4em] uppercase text-misty-dim font-sans">
            Age Verification
          </p>
          <h2
            className="font-display text-4xl sm:text-5xl lg:text-6xl text-misty-text tracking-wide"
            data-testid="age-gate-question"
          >
            Are You 18 or Older?
          </h2>
          <p className="text-misty-muted text-sm sm:text-base max-w-md mx-auto leading-relaxed">
            This website contains content related to nicotine vaping products
            and is intended for adults only.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto pt-2">
          <button
            onClick={onConfirm}
            className="bg-misty-steel hover:bg-misty-steelHi text-misty-base px-10 py-4 font-sans font-semibold tracking-[0.15em] uppercase text-xs transition-colors"
            data-testid="age-gate-yes-button"
          >
            Yes, I am 18+
          </button>
          <button
            onClick={() => window.history.back()}
            className="border border-white/20 hover:border-misty-steel text-misty-text hover:text-misty-steel px-10 py-4 font-sans tracking-[0.2em] uppercase text-xs transition-colors"
            data-testid="age-gate-no-button"
          >
            No, Go Back
          </button>
        </div>
        <p className="text-misty-dim text-[10px] tracking-[0.2em] uppercase pt-4">
          By entering you confirm you are of legal age in your region.
        </p>
      </div>
    </div>
  );
};
